import React, { Fragment, useEffect } from 'react';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import DefaultContain from 'Component/DashboardQeza/Banner';

const Banner = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Fragment>
            <Breadcrumbs parent="Banner" title="Daftar Banner" />
            <DefaultContain />
        </Fragment>
    );
};
export default Banner;